import { createAction } from "@ngrx/store";

export const endNavigation = createAction("[Navmenu] End Navigation");
